import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TabNavigation = ({ activeTab, onTabChange, hasUnsavedChanges = false }) => {
  const tabs = [
    {
      id: 'overview',
      label: 'Overview',
      icon: 'User',
      description: 'Basic student information and profile'
    },
    {
      id: 'behavior-support-plan',
      label: 'Behavior Plan',
      icon: 'ClipboardList',
      description: 'PBIS-aligned BIP: target behavior, function, replacement, SMART goal, MTSS tier'
    },
    {
      id: 'iep-goals',
      label: 'IEP Goals',
      icon: 'Target',
      description: 'Goals, objectives, and progress tracking'
    },
    {
      id: 'behavioral',
      label: 'Behavioral Data',
      icon: 'BarChart3',
      description: 'Behavioral incidents and patterns'
    },
    {
      id: 'documents',
      label: 'Documents',
      icon: 'FileText',
      description: 'Files, reports, and attachments'
    }
  ];

  const handleTabClick = (tabId) => {
    if (hasUnsavedChanges && tabId !== activeTab) {
      if (window.confirm('You have unsaved changes. Are you sure you want to switch tabs?')) {
        onTabChange(tabId);
      }
    } else {
      onTabChange(tabId);
    }
  };

  return (
    <div className="border-b border-border bg-surface">
      <div className="flex items-center justify-between px-6 py-4">
        <nav className="flex space-x-1" role="tablist">
          {tabs?.map((tab) => {
            const isActive = activeTab === tab?.id;
            
            return (
              <Button
                key={tab?.id}
                variant={isActive ? 'default' : 'ghost'}
                onClick={() => handleTabClick(tab?.id)}
                className={`flex items-center gap-2 px-4 py-2 text-sm font-medium transition-all duration-200 ${
                  isActive 
                    ? 'bg-primary text-primary-foreground shadow-sm' 
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
                role="tab"
                aria-selected={isActive}
                aria-controls={`${tab?.id}-panel`}
                title={tab?.description}
              >
                <Icon name={tab?.icon} size={16} />
                <span className="hidden sm:inline">{tab?.label}</span>
                {/* Mobile label */}
                <span className="sm:hidden text-xs">{tab?.label?.split(' ')?.[0]}</span>
              </Button>
            );
          })}
        </nav>
        
        {/* Tab Actions */}
        <div className="flex items-center gap-2">
          {hasUnsavedChanges && (
            <div className="flex items-center gap-2 text-sm text-warning">
              <Icon name="AlertCircle" size={16} />
              <span className="hidden sm:inline">Unsaved changes</span>
            </div>
          )}
          
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            className="hidden md:flex"
          >
            Export
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            iconName="Printer"
            iconPosition="left"
            className="hidden lg:flex"
          >
            Print
          </Button>
        </div>
      </div>
      {/* Tab Indicator */}
      <div className="px-6">
        <div className="text-xs text-muted-foreground pb-2">
          {tabs?.find(tab => tab?.id === activeTab)?.description}
        </div>
      </div>
    </div>
  );
};

export default TabNavigation;